import {
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'lib-paginator',
  imports: [],
  templateUrl: './paginator.html',
  styleUrl: './paginator.scss',
})
export class Paginator {
  @Input() total: number = 0; // total records
  @Input() pageSize = 10; // items per page
  @Input() pageIndex = 0; // zero-based
  totalPages = 0;

  @Output() pageChange = new EventEmitter<number>();

  get rangeText() {
    if (this.total === 0) return 'Showing 0-0 from 0';
    const start = this.pageIndex * this.pageSize + 1;
    const end = Math.min((this.pageIndex + 1) * this.pageSize, this.total);

    return `Showing ${start}-${end} from ${this.total}`;
  }

  get canPrev() {
    return this.pageIndex > 0;
  }
  get canNext() {
    return this.pageIndex < this.totalPages - 1;
  }

  ngOnChanges() {
    if (this.pageSize > 0) {
      this.totalPages = Math.ceil(this.total / this.pageSize);
    } else {
      this.totalPages = 0;
    }
  }

  prev() {
    if (!this.canPrev) return;
    const newPageIndex = this.pageIndex - 1;
    this.pageChange.emit(newPageIndex);
  }

  next() {
    if (!this.canNext) return;
    const newPageIndex = this.pageIndex + 1;
    this.pageChange.emit(newPageIndex);
  }
}
